var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tooltip',{directives:[{name:"ak-tooltip-auto-show",rawName:"v-ak-tooltip-auto-show"}],attrs:{"placement":"top","content":_vm.row.title}},[_c('div',{staticClass:"line-ellipsis-2 yx-color-pure-1",staticStyle:{"width":"100%"}},[_vm._v("\n\t\t\t"+_vm._s(_vm.row.title)+"\n\t\t")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }